import Home from './home'
import CollectionRecord from './collectionRecord'
import AddApply from './addApply'
import ApplyDetail from './applyDetail'
import MorePage from './morepage'
export default {
  Home,
  CollectionRecord,
  AddApply,
  ApplyDetail,
  MorePage
}
